<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  active: Boolean,
  href: {
    type: [String, Boolean],
    default: false
  },
  title: String
});
</script>

<template>
  <Link :href="href" prefetch>
    <div
      class="mx-2 p-2 md:my-0 md:py-3 lg:px-8"
      :class="{
        'nav-active bg-nav-item rounded-[var(--nav-item-radius)] font-bold md:px-8! md:text-center':
          active
      }"
    >
      <slot />
    </div>
  </Link>
</template>
